// @flow @jsx h

/* eslint-disable promise/catch-or-return */
/* eslint-disable promise/always-return */
/* eslint-disable jsx-a11y/aria-role */
/* eslint-disable compat/compat */

import { Component, h } from 'preact'
import { SmartVideo } from '@nrk/dh-feature-components'
import { toVideoSrc } from '../../../common'

import styles from './index.css'
import '@nrk/dh-feature-components/dist/module/video/SmartVideo/index.css'
import type { VideoType } from '../../domain'

type Props = {
  sted: string,
  info: string,
  alt: string,
  horizontal: VideoType,
  vertical: VideoType,
  playing: boolean,
  viewport: { width: number, height: number }
}

export class StedintroVideoBlokk extends Component<Props> {
  animationElm: HTMLElement
  animation: any
  animationData: any
  lottie: any

  componentDidMount () {
    Promise.all([
      require('../../../../lib/wrappers/lottieWrapper').getLottie(),
      fetch('https://static.nrk.no/dh/gfx/2019/sporten/vbm/lottie/sted_moh_mal_ny2.json').then(res => res.json())
    ])
      .then(
        ([lottie, animationData]) => {
          animationData.layers[3].t.d.k[0].s.t = this.props.sted.toUpperCase()
          animationData.layers[4].t.d.k[0].s.t = this.props.info

          this.lottie = lottie
          this.animationData = animationData
        })
  }

  handleEnter () {
    this.animation = this.lottie.loadAnimation({
      container: this.animationElm, // the dom element that will contain the animation
      renderer: 'svg',
      loop: false,
      autoplay: false,
      rendererSettings: { preserveAspectRatio: 'xMinYMax meet' },
      animationData: this.animationData
    })
    this.animation.setSpeed(1.5)
    this.animation.play()
  }

  handleLeave () {
    this.animation.destroy()
    delete this.animation
  }

  componentDidUpdate (previousProps: Props) {
    if (this.lottie && !previousProps.playing && this.props.playing) {
      this.handleEnter()
    }

    if (this.animation && previousProps.playing && !this.props.playing) {
      this.handleLeave()
    }
  }

  isHorizontal = () => {
    if (typeof window !== 'undefined' && window.matchMedia) {
      return window.matchMedia('(min-width: 720px)').matches
    } else {
      return false
    }
  }

  render () {
    const { playing, horizontal, vertical, viewport } = this.props

    return <div class={styles.stedintroVideoBlokk}>
      <SmartVideo
        title={this.props.alt}
        playing={playing}
        loop
        muted
        playsInline
        preload='none'
        isHorizontal={this.isHorizontal}
        resolution720p={toVideoSrc(horizontal)}
        resolution1080p={toVideoSrc(horizontal)}
        resolution960p={toVideoSrc(vertical)}
        viewport={viewport} />
      <div
        class={styles.stedintroVideoBlokk__anim}
        ref={elm => (this.animationElm = elm)}
        aria-label={this.props.sted + ' ' + this.props.info} role='text' />
    </div>
  }
}
